<div class="funfacts-area bg-f5f7fa">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-6">
                <div class="single-funfacts">
                    <img src="images/funfacts-shape2.png" alt="image">
                    <h3>2k+</h3>
                    <p>Current Enrollments</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
                <div class="single-funfacts">
                    <img src="images/funfacts-shape2.png" alt="image">
                    <h3>90+</h3>
                    <p>Qualified Staff</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
                <div class="single-funfacts">
                    <img src="images/funfacts-shape2.png" alt="image">
                    <h3>80+</h3>
                    <p>Clubs & Activities</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
                <div class="single-funfacts">
                    <img src="images/funfacts-shape2.png" alt="image">
                    <h3>100+</h3>
                    <p>Active PTFA Members</p>
                </div>
            </div>
        </div>
    </div>
</div>